export default "__VITE_ASSET__B6H0wPhC__"